module.exports = __webpack_public_path__ + "static/img/rage-strike-seasonalShop-scaled@2x.4ad94320.png";